// Workflow CLI 常量定义

// 目录和文件
export const WORKFLOW_DIR = '.workflow';
export const CONFIG_FILE = 'config.json';
export const COMMANDS_DIR = 'commands';
export const WORKFLOWS_DIR = 'workflows';
export const KNOWLEDGE_DIR = 'knowledge';
export const LOGS_DIR = 'logs';

// 默认配置
export const DEFAULT_SYNC_INTERVAL = 300000; // 5 minutes
export const DEFAULT_COMMAND_TIMEOUT = 30000; // 30 seconds
export const DEFAULT_SEARCH_LIMIT = 10;
export const DEFAULT_LIST_LIMIT = 20;

// 命令名称
export const AVAILABLE_COMMANDS = ['init', 'todo', 'context', 'review'] as const;
export const AVAILABLE_WORKFLOWS = ['feature', 'bugfix', 'refactor'] as const;
export const KNOWLEDGE_TYPES = ['pattern', 'decision', 'troubleshooting', 'snippet'] as const;

// 文件扩展名
export const MARKDOWN_EXTENSIONS = ['.md', '.markdown'];
export const YAML_EXTENSIONS = ['.yaml', '.yml'];

// TODO 文件可能的位置
export const TODO_FILE_PATHS = [
  'TODO.md',
  'todo.md',
  'TODO.txt',
  'todo.txt',
  'docs/TODO.md',
  'docs/todo.md',
  '.github/TODO.md',
  'project-docs/TODO.md'
];